import { Award, AlertTriangle, CheckCircle2 } from "lucide-react";

const EXPIRY_WARNING_DAYS = 30;

function CertStatus({ daysLeft }) {
  if (daysLeft === null || daysLeft === undefined) {
    return <span className="text-[var(--text-2)] font-mono text-xs">No expiry data</span>;
  }
  if (daysLeft < 0) {
    return (
      <span className="text-[var(--red)] inline-flex items-center gap-1 font-mono text-xs">
        <AlertTriangle size={12} /> EXPIRED {Math.abs(daysLeft)}d ago
      </span>
    );
  }
  if (daysLeft <= EXPIRY_WARNING_DAYS) {
    return (
      <span className="text-[var(--amber)] inline-flex items-center gap-1 font-mono text-xs">
        <AlertTriangle size={12} /> Expires in {daysLeft}d
      </span>
    );
  }
  return (
    <span className="text-[var(--green)] inline-flex items-center gap-1 font-mono text-xs">
      <CheckCircle2 size={12} /> Valid &middot; {daysLeft}d left
    </span>
  );
}

function certColor(days) {
  if (days === null || days === undefined) return "var(--text-2)";
  if (days < 0) return "var(--red)";
  if (days <= EXPIRY_WARNING_DAYS) return "var(--amber)";
  return "var(--green)";
}

export default function CertList({ certifications }) {
  return (
    <div className="flat-card p-6" data-testid="sd-certs-card">
      <div className="overline">// 02_CERTIFICATIONS</div>
      <h2 className="font-display font-bold text-2xl uppercase mt-1 mb-4">Certifications</h2>
      <div className="space-y-3">
        {certifications.length === 0 && (
          <div className="text-sm text-[var(--text-2)]">No certifications awarded.</div>
        )}
        {certifications.map((c) => (
          <div key={c.id} className="border border-[var(--border)] p-3" data-testid={`sd-cert-${c.course?.code}`}>
            <div className="flex items-start justify-between gap-2">
              <div>
                <div className="font-mono text-xs text-[var(--cyan)]">{c.course?.code}</div>
                <div className="font-display font-bold uppercase text-sm">{c.course?.title}</div>
              </div>
              <Award size={16} color={certColor(c.days_left)} strokeWidth={1.5} />
            </div>
            <div className="mt-2"><CertStatus daysLeft={c.days_left} /></div>
          </div>
        ))}
      </div>
    </div>
  );
}
